<div class="bg-gif">
    <div class="content-wrapper">
        <h1 class="font-white">404</h1>
        <mat-card-title class="font-white margin-bottom-md">Oops, the page you're looking for does not exist.</mat-card-title>
        <mat-divider style="border-top-color: white;" class="mat-divider-inherit-with-margin"></mat-divider>
        <mat-card-subtitle class="font-white margin-bottom-md">You may want to head back to the homepage.</mat-card-subtitle>
        <div>
            <button mat-flat-button (click)="goHome()">Return Home</button>
        </div>
    </div>
</div>
